import { useCallback } from 'react';

import { useAuth } from '../../authentication';
import { useNotifications } from '../../../providers/NotificationsProvider';
import { useOrganizations } from '../../organization/providers';

import { useDeleteShareMutation } from './useDeleteShareMutation';

const useDeleteShare = ({ successMessage, failureMessage } = {}) => {
  const { accessToken } = useAuth();
  const { currentOrganization } = useOrganizations();
  const { addNotification } = useNotifications();

  const deleteShareMutation = useDeleteShareMutation(accessToken, currentOrganization?.id);

  return useCallback(
    async (shareId) => {
      try {
        await deleteShareMutation.mutateAsync(shareId);
        addNotification({
          icon: 'trash',
          message: successMessage ?? 'Share has been declined'
        });
      } catch (err) {
        addNotification({
          icon: 'alert',
          message: failureMessage ?? 'Failed to decline share'
        });
      }
    },
    [deleteShareMutation]
  );
};

export { useDeleteShare };
